import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
interface ButtonComponentProps {
  onClick: () => void;
  label: string;
  keyName: string;
  disabled?: boolean;
}
const AddButtonComponent: React.FC<ButtonComponentProps> = ({
  onClick,
  label,
  keyName,
  disabled,
}) => {
  return (
    <Button
      style={{
        textDecoration: 'none',
        textTransform: 'capitalize',
        color: 'rgba(0, 244, 255, 1)',
        background: 'rgb(1, 1, 1)',
      }}
      id={keyName}
      disabled={disabled}
      key={keyName}
      variant="contained"
      onClick={() => {
        onClick();
      }}
      startIcon={<AddIcon sx={{ color: 'rgba(0, 244, 255, 1)' }} />}
    >
      {label}
    </Button>
  );
};
export default AddButtonComponent;
